import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import { Globals } from '../globals';
import { FirestoreService } from './firestore/firestore.service';

interface User {
    email: string;
    groups?: any;
    lastName?: string;
    name?: string;
    password?: string;
    photoUrl: any;
    createdAt?: any;
    updatedAt?: any;
    superadmin?: boolean;
}

interface UserId extends User {
    id: string;
}

interface Permission {
    name: string;
    level: number;
    createAction: boolean;
    readAction: boolean;
    updateAction: boolean;
    deleteAction: boolean;
}

interface PermissionId extends Permission {
    id: string;
}

@Injectable()
export class PermissionService {

    userCollection: AngularFirestoreCollection<User>;
    users: any;

    permissionCollection: any;

    collectionUser: string;
    collectionGroup: string;

    constructor(private afs: AngularFirestore, private afh: FirestoreService) {
        this.collectionUser = Globals.USER_COLLECTION;
        this.collectionGroup = Globals.GROUP_COLLECTION;
    }

    getUserPermissionByEmail(email: string) {
        this.userCollection = this.afs.collection(this.collectionUser, ref => ref.where('email', '==', email));

        this.users = this.userCollection.snapshotChanges().map(actions => {
            return actions.map(a => {
                const id$ = a.payload.doc.id;

                const data = a.payload.doc.data() as User;

                const groups = data.groups;
                const superadmin = data.superadmin || false;

                return { id$, superadmin, groups };
            });
        }).map(documents => {
            return documents[0].groups.map(group => {
                this.permissionCollection = this.afs.doc(this.collectionGroup + '/' + group).collection('permission');

                const permissionRef: any = this.permissionCollection.snapshotChanges().map(actions => {
                    return actions.map(a => {
                        const id$ = a.payload.doc.id;

                        const data = a.payload.doc.data() as Permission;

                        return { id$, ...data };
                    });
                });
                let groupRef = this.afh.docWithIds$(`${this.collectionGroup}/${group}`);

                return Observable.combineLatest(permissionRef, groupRef, (permissionData, groupData) => {
                    return {
                        permissions: permissionData,
                        group: groupData
                    };
                }).map(data => {
                    return {
                      permissions: data.permissions,
                      superadmin: documents[0].superadmin,
                      ...data.group
                    };
                });
            });
        }).mergeMap(object => {
            return object.length === 0 ? Observable.of([]) : Observable.combineLatest(object);
        });
        return this.users;
    }

    constructPermissionObject([group0, ...groups]: any[], permissionId: string){
        let permissionObj;
        if(permissionId != 'SPECIAL'){
            permissionObj = group0.permissions.find(({id$}) => id$ == permissionId);
            groups.map(({permissions}) => {
                let {...permission} = permissions.find(({id$}) => id$ == permissionId) || {};
                if(permission.createAction) permissionObj.createAction = true;
                if(permission.readAction) permissionObj.readAction = true;
                if(permission.updateAction) permissionObj.updateAction = true;
                if(permission.deleteAction) permissionObj.deleteAction = true;
            });
        }else{
            //console.log(group0, groups);
            permissionObj = group0.specialPermissions || {};
            groups.map(({specialPermissions={}}) => {
                Object.keys(specialPermissions).map(key => {
                    if(specialPermissions[key]) permissionObj[key] = true;
                });
            });
            //console.log(permissionObj);
        }
        return permissionObj;
    }

}

export enum SpecialPermissions{
    qualityCertificate = 'Certificado de calidad',
    passwordEditing = 'Editar contraseñas',
    prClientPreProduction = 'Estatus de pre-producción',
    prClientQuality = 'Estatus de calidad',
    rentabilityReport = 'Reporte de rentabilidad',
    yearlyReport = 'Reporte acumulado',
    customersTransactionReport = 'Cuentas x Cobrar - Estado de cuenta',
    customerBillExpiration = 'Cuentas x Cobrar - Vencimiento de saldos',
    billReportDetail = "Cuentas x Cobrar - Reporte detallado",
    suppliersTransactionReport = "Cuentas x Pagar - Reporte de gastos",
    supplierBillExpiration = 'Cuentas x Pagar - Vencimiento de saldos',
    purchaseReport = 'Reporte de compras',
    remissionSetFree = 'Liberar remisiones',
}
